// Meta Pixel helper — wraps fbq() so app code can fire events without
// worrying whether the pixel script has loaded.
//
// Pixel ID: 995253706313859 (also hardcoded in /public/index.html)

const safeFbq = (...args) => {
  if (typeof window === 'undefined') return;
  if (typeof window.fbq !== 'function') return;
  try {
    window.fbq(...args);
  } catch (e) {
    // Pixel blockers (uBlock, etc.) will swallow this — that's fine.
  }
};

/** Fire a standard Meta Pixel event. */
export const trackPixel = (event, params) => {
  if (params && Object.keys(params).length) {
    safeFbq('track', event, params);
  } else {
    safeFbq('track', event);
  }
};

/** Fire a custom (non-standard) Meta Pixel event. */
export const trackPixelCustom = (event, params) => {
  if (params && Object.keys(params).length) {
    safeFbq('trackCustom', event, params);
  } else {
    safeFbq('trackCustom', event);
  }
};

/** PageView — fired on every SPA route change. */
export const trackPixelPageView = () => safeFbq('track', 'PageView');
